const CONFIG_CATEGORIES = {
  PACIENTE: `paciente`,
  COLORS: `colors`,
  INTEGRATION: `integration`,
  MONITOR: `monitor`,
}

const CONFIG_KEYS = {
  PACIENTE: {
    ADMIT_SOCIAL_NAME: `admitSocialName`,
  },
  COLORS: {
    TOTEM: `totem`,
    TV: `tv`,
  },
  INTEGRATION: {
    CALL_PLACE: `callPlace`,
  },
  MONITOR: {
    TAGS_FILTER_ENABLED: `tagsFilterEnabled`,
  },
}

export { CONFIG_CATEGORIES, CONFIG_KEYS }
